import $ from "jquery";
import moment from "moment";

/**
 * テンプレートのセッター
 *
 * @param {$Object | String} selector
 * @returns this
 */
function setArticleTemplate(selector) {
	let $template;
	
	if(selector instanceof $) {
		$template = selector;
	} else
	if(selector) {
		$template = $(selector);
	}
	
	if(!$template || !$template.length) {
		if(this.$self) {
			$template = this.$self.children().eq(-1);
			if(!$template.length) {
				$template = undefined;
			}
			
		} else {
			$template = undefined;
		}
	}
	
	if($template) {
		!$template.attr("id") && $template.attr({
			"id": [this.name, "replicant", "template", moment().valueOf()].join("_")
		});
		
		if(this.$replicantTemplate) {
			this.$replicantTemplate.replaceWith($template);
			this.$replicantTemplate = $template;
			
		} else {
			this.$replicantTemplate = $template.appendTo( this.getTemplateArea() );
		}
		
		this.getReplicants().forEach(vuw => {
			if(vuw.isReady) {
				const $elm = vuw.createDefaultElement();
				vuw.$self.replaceWith($elm);
				vuw.$self = $elm;
				vuw.$template = this.$replicantTemplate;
			}
		});
		
	} else
	if(this.$replicantTemplate) {
		this.$replicantTemplate.remove();
		delete this.$replicantTemplate;
	}
	
	return this;
}

export default setArticleTemplate
